/**
 * Page context for Harry (panel + header spin).
 */

const PAGE_OVERVIEWS: { match: string; title: string; overview: string }[] = [
  { match: '/prioritization/items', title: 'Items', overview: 'Your full library of items. Add to it, classify, dedupe, or map how items relate.' },
  { match: '/prioritization/intake', title: 'Intake', overview: 'Where new ideas come in. Capture items and triage what others submitted.' },
  { match: '/prioritization/scribe', title: 'Scribe', overview: 'Dictate or paste free-form text and Scribe turns it into structured item proposals.' },
  { match: '/prioritization/scoring', title: 'Scoring', overview: 'Evaluate items against your criteria and weights to build a ranking.' },
  { match: '/prioritization/sessions', title: 'Sessions', overview: 'Run a live group session to vote on and rank items together.' },
  { match: '/prioritization/relationships', title: 'Relationships', overview: 'See and shape how items depend on, break down, or roll up into each other.' },
  { match: '/prioritization/reports', title: 'Reports', overview: 'Insights a ranked list hides — readiness, fragility, strategy gaps, and leverage.' },
  { match: '/prioritization/dashboard', title: 'Dashboard', overview: 'Your starting point. From here you can reach every part of the workflow.' },
];

export function harryPageContext(pathname: string): { title: string; overview: string; pathname: string } {
  const hit = PAGE_OVERVIEWS.find(
    (p) => pathname === p.match || pathname.startsWith(`${p.match}/`) || pathname.startsWith(p.match),
  );
  return hit
    ? { title: hit.title, overview: hit.overview, pathname }
    : { title: 'Workspace', overview: 'Tell Harry what you want to do, or browse what you can get done here.', pathname };
}
